import { useCallback, useState } from 'react'

export const useDisclosure = (
  initialState = false,
  callbacks?: { onClose?(): void; onOpen?(): void }
) => {
  const { onClose, onOpen } = callbacks || {}
  const [opened, setOpened] = useState(initialState)

  const open = useCallback(() => {
    setOpened(isOpened => {
      if (!isOpened) {
        onOpen?.()
        return true
      }
      return isOpened
    })
  }, [onOpen])

  const close = useCallback(() => {
    setOpened(isOpened => {
      if (isOpened) {
        onClose?.()
        return false
      }
      return isOpened
    })
  }, [onClose])

  const toggle = useCallback(() => {
    opened ? close() : open()
  }, [close, open, opened])

  return [opened, { close, open, toggle }] as const
}
